import type { UseUserDrawerControllerResult } from './useUserDrawerController';
import { UserDrawer } from './UserDrawer';

interface UserDrawerHostProps {
    controller: UseUserDrawerControllerResult;
}

// Mounts the UserDrawer (which owns its own DiscardUserDrawerModal) plus the
// deep-link loading overlay, driven entirely by useUserDrawerController -
// shared by the Accounts > Users page and the practice detail page's Users
// tab so both surfaces open the exact same drawer in place.
export function UserDrawerHost({ controller }: UserDrawerHostProps) {
    const {
        isCreateOpen,
        editEmail,
        editUser,
        initialConfirmDelete,
        isDeepLinkLoading,
        closeDrawer
    } = controller;

    return (
        <>
            {(isCreateOpen || editUser) && (
                <UserDrawer
                    // Forces a fresh mount (and a fresh useUserDrawerForm
                    // snapshot) whenever the drawer switches between create
                    // and a specific user, or between two different users.
                    key={isCreateOpen ? 'create' : (editEmail ?? undefined)}
                    mode={isCreateOpen ? 'create' : 'edit'}
                    user={editUser}
                    initialConfirmDelete={initialConfirmDelete}
                    onClose={closeDrawer}
                />
            )}

            {isDeepLinkLoading && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/10">
                    <div className="h-8 w-8 rounded-full border-2 border-gray-300 border-t-gray-800 animate-spin" />
                </div>
            )}
        </>
    );
}
